









import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 * 提示信息
 *
 * @author liyuyao
 * @date 08/24/2020
 */
@Component
export default class InfoTip extends Vue {
    @Prop({ default: '' })
    content: string;

    @Prop({ default: 'right' })
    placement: string;

    @Prop({ default: 14 })
    size: number;
}
